<template>
	<div class="question-wrapper">
		<div class="question">
			<label>{{
					question.name
				}}</label>
			<div class="radio-options">
				<div v-for="(option, index) in config.options" class="option">
					<input :id="'kmk.' + index" type="radio" :value="option" v-model="answer.value" :disabled="disabled"
						   :name="index" name="kmk" @change="valueChanged">
					<label :for="'kmk.' + index" @change="valueChanged">{{ option }}</label>
				</div>
			</div>
		</div>
		<div v-if="answer.value === 'Ja'">
			<div class="kmk-line" v-for="row in answer.text_value">
				<input placeholder="Naam" v-model="row.name"/>
				<input placeholder="Telefoonnummer" v-model="row.phone"/>
				<input placeholder="Woonplaats" v-model="row.city"/>
				<button type="button" @click="addLine">
					<PlusIcon/>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PlusIcon} from "vue-feather-icons";

export default {
	components: {
		PlusIcon
	},
	data() {
		return {
			options: []
		};
	},

	props: {
		config: {
			type: Object,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
		question: {
			type: Object,
			default: ""
		},
		answer: {
			type: Object,
			default: ""
		}
	},

	created() {

	},
	methods: {
		valueChanged() {
			if (this.answer.value === "Ja") {
				this.addLine();
			} else {
				this.answer.text_value = null;
				this.$forceUpdate();
			}
		},
		addLine() {
			if (this.answer.text_value === null) {
				this.answer.text_value = [];
			}
			this.answer.text_value.push({
				name: "",
				phone: "",
				city: ""
			});
			this.$forceUpdate();
		}
	}
};
</script>

<style scoped lang="scss">
.question-wrapper {
	width: 100%;
}

.question {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
	width: 100%;

	label {
		font-size: 1.2rem;
		font-weight: 500;
		min-width: 200px;
	}

	.radio-options {
		//min-width: 50%;
		display: flex;
		justify-content: flex-end;

		input {
			width: 24px;
			height: 24px;
		}

		.option {
			display: flex;
			align-items: center;

			label {
				min-width: unset;
				white-space: nowrap;
				font-weight: normal;
				padding: 8px 16px 8px 8px;
			}
		}
	}
}

.kmk-line {
	display: flex;
	flex-direction: row;
	gap: 24px;
	margin-top: 8px;

	input {
		border: 2px solid #ced6dd;
		padding: 6px;
		border-radius: 5px;
		height: 36px;
		box-sizing: border-box;
		width: 100%;
		background: #ffffff;
	}
}

button {
	margin-left: 8px;
	border: 2px solid #35a5a4;
	color: #35a5a4;
	width: 64px;
	min-width: 64px;
	background: #ffffff;
	height: 36px;
	align-items: center;
	display: flex;
	justify-content: center;
	border-radius: 5px;
}
</style>
